import clsx from 'clsx'
import {FC, PropsWithChildren} from 'react'
import {HeaderProps, UseSortByColumnProps} from 'react-table'
import {User} from '../../core/_models'
import {KTIcon} from '../../../../../../../_metronic/helpers'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<
    HeaderProps<User> & {
      column: UseSortByColumnProps<User> & {
        sortable?: boolean
      }
    }
  >
}

const UserCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const {column} = tableProps
  const isSortingEnabled = column.sortable !== false

  return (
    <th
      {...column.getHeaderProps(isSortingEnabled ? column.getSortByToggleProps() : undefined)}
      className={clsx(className, isSortingEnabled ? 'cursor-pointer' : '')}
    >
      <div className='d-flex align-items-center justify-content-center'>
        {title}
        {isSortingEnabled && (
          <span className='ms-1'>
            {column.isSorted ? (
              column.isSortedDesc ? (
                <KTIcon iconName='arrow-down' className='fs-7' />
              ) : (
                <KTIcon iconName='arrow-up' className='fs-7' />
              )
            ) : (
              <KTIcon iconName='sorting' className='fs-7 text-muted' />
            )}
          </span>
        )}
      </div>
    </th>
  )
}

export {UserCustomHeader}
